import { z } from 'zod'

const envSchema = z.object({
  VITE_API_URL: z.string().url(),
  VITE_SENTRY_DSN: z.string().optional(),
  VITE_ENABLE_BILLING: z
    .enum(['true', 'false'])
    .default('true')
    .transform((v) => v === 'true'),
})

export const env = envSchema.parse(import.meta.env)
